// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2i5rU","Label":"Input_Label__2DS_t","InputElement":"Input_InputElement__jInGe","Invalid":"Input_Invalid__3Mbz5"};